import {AbstractControl, NG_VALIDATORS, Validator, ValidatorFn} from '@angular/forms';
import {Directive, Input} from '@angular/core';
import {FunctionUtils} from '@sharedcommon/util/functions.util';

@Directive({
  selector: '[minvalue]',
  providers: [{provide: NG_VALIDATORS, useExisting: MinValueValidatorDirective, multi: true}]
})
export class MinValueValidatorDirective implements Validator {

  @Input() minvalue: number;

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.minvalue ? minValueValidator(this.minvalue)(control) : null;
  }
}

export function minValueValidator(min: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return FunctionUtils.isDefined(control.value) && Number(control.value) < min ? {'min': {value: control.value}} : null;
  };
}
